<template>
  <div class="org-list mt3">
    <h3 class="caps red mb0 border-bottom pb1">{{ title }}</h3>
    <ul class="list-reset m1 sm-m0 md-m0 lg-m0 p0 flex flex-column" >
      <li class="mb3 flex items-center justify-between" v-for="(item, index) in content" :key="index">
        <div>
          <span class="red">{{ item.organization.post_title }}</span>
          <span v-if="item.details"><br/>{{ item.details }}</span>
        </div>
        <a v-if="item.organization.url" :href="item.organization.url" target="_blank" class="block">
          <div class="logo-wrapper flex items-center">
            <img class="block" v-if="item.organization.logo" :alt="`${item.organization.post_title} logo`" :data-src="item.organization.logo.sizes.medium" />
          </div>
        </a>
        <div v-else class="logo-wrapper flex items-center">
          <img class="block" v-if="item.organization.logo" :alt="`${item.organization.post_title} logo`" :data-src="item.organization.logo.sizes.medium" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {

  name: 'OrgList',

  data () {
    return {

    }
  },

  props: ['title', 'content'],

}
</script>

<style lang="css" scoped>
  .org {
    border: 1px solid var(--black);
    text-align: center;
    border-radius: 8px;
    margin-bottom: 1em;
    padding: 1em;
  }

  .org-list {
    .logo-wrapper {
      width: 120px;
      height: 120px;

      img {
        object-fit: contain;
      }
    }
  }

  .box {
    flex: 1 0 auto;
    position: relative;

    .inner {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .box:after {
      content: "";
      float:left;
      display: block;
      padding-top: 100%;
  }

  ul {
    li {
      vertical-align: top;
      a {
        border: none;
      }
      img {
        filter: grayscale(1);
      }
    }
  }
</style>
